import React from 'react'

const AssessmentMethodUsed = (props) => {
    let { assessmentData, setAssessmentData, setSaveAssessmentMethodUsedData } = { ...props };
    let assessmentMethodUsed = assessmentData?.AssessmentMethodUsed;

    const handleAssessmentMethodUsed = (e) => {
        let { name } = e.target;
        console.log("handleObjectiveFindingobjectiveFindingData", name)
        setAssessmentData(prev => {
        console.log("handleObjectiveFindingobjectiveFindingData123", {
                ...prev,
                'AssessmentMethodUsed': {
                    ...prev?.AssessmentMethodUsed,
                    [name]: prev?.AssessmentMethodUsed?.[name] === "true" ? "false" : "true",
                },
            })
            return ({
                ...prev,
                'AssessmentMethodUsed': {
                    ...prev?.AssessmentMethodUsed,
                    [name]: prev?.AssessmentMethodUsed?.[name] === "true" ? "false" : "true",
                },
            });
        });

        setSaveAssessmentMethodUsedData(prev => ({
            ...prev,
            [name]: prev[name] === "true" ? "false" : "true"
        }));
    }
  return (
    <div className="d-flex gap-40">
      <div className="d-flex flex-column gap-2">
        <label className="d-flex align-items-center gap-6 user-select-none">
          <div className="custom_check_box d-flex">
            <input 
              type="checkbox" 
              className="form-check-input m-0 p-0" 
              name="MassageTherapy"
              id="MassageTherapy"
              checked={assessmentMethodUsed?.MassageTherapy === "true"}
              onChange={handleAssessmentMethodUsed}
            />
          </div>
          <p className="text lh-12">Massage Therapy</p>
        </label>
        <label className="d-flex align-items-center gap-6 user-select-none">
          <div className="custom_check_box d-flex">
            <input 
              type="checkbox" 
              className="form-check-input m-0 p-0" 
              name="Craniosacral"
              id="Craniosacral"
              checked={assessmentMethodUsed?.Craniosacral === "true"}
              onChange={handleAssessmentMethodUsed}
            />
          </div>
          <p className="text lh-12">Craniosacral</p>
        </label>
        <label className="d-flex align-items-center gap-6 user-select-none">
          <div className="custom_check_box d-flex">
            <input 
              type="checkbox" 
              className="form-check-input m-0 p-0" 
              name="Cupping"
              id="Cupping"
              checked={assessmentMethodUsed?.Cupping === "true"}
              onChange={handleAssessmentMethodUsed}
            />
          </div>
          <p className="text lh-12">Cupping</p>
        </label>
        <label className="d-flex align-items-center gap-6 user-select-none">
          <div className="custom_check_box d-flex">
            <input 
              type="checkbox" 
              className="form-check-input m-0 p-0" 
              name="JointMobilization"
              id="JointMobilization"
              checked={assessmentMethodUsed?.JointMobilization === "true"}
              onChange={handleAssessmentMethodUsed}
            />
          </div>
          <p className="text lh-12">Joint Mobilization</p>
        </label>
        <label className="d-flex align-items-center gap-6 user-select-none">
          <div className="custom_check_box d-flex">
            <input 
              type="checkbox" 
              className="form-check-input m-0 p-0" 
              name="LymphDrainage"
              id="LymphDrainage"
              checked={assessmentMethodUsed?.LymphDrainage === "true"}
              onChange={handleAssessmentMethodUsed}
            />
          </div>
          <p className="text lh-12">Lymph Drainage</p>
        </label>
      </div>

      <div className="d-flex flex-column gap-2">
        <label className="d-flex align-items-center gap-6 user-select-none">
          <div className="custom_check_box d-flex">
            <input 
              type="checkbox" 
              className="form-check-input m-0 p-0" 
              name="MyofascialRelease"
              id="MyofascialRelease"
              checked={assessmentMethodUsed?.MyofascialRelease === "true"}
              onChange={handleAssessmentMethodUsed}
            />
          </div>
          <p className="text lh-12">Myofascial Release</p>
        </label>
        <label className="d-flex align-items-center gap-6 user-select-none">
          <div className="custom_check_box d-flex">
            <input 
              type="checkbox" 
              className="form-check-input m-0 p-0" 
              name="NeuroMobilization"
              id="NeuroMobilization"
              checked={assessmentMethodUsed?.NeuroMobilization === "true"}
              onChange={handleAssessmentMethodUsed}
            />
          </div>
          <p className="text lh-12">Neuro Mobalization</p>
        </label>
        <label className="d-flex align-items-center gap-6 user-select-none">
          <div className="custom_check_box d-flex">
            <input 
              type="checkbox" 
              className="form-check-input m-0 p-0" 
              name="Stretching"
              id="Stretching"
              checked={assessmentMethodUsed?.Stretching === "true"}
              onChange={handleAssessmentMethodUsed}
            />
          </div>
          <p className="text lh-12">Stretching</p>
        </label>
        <label className="d-flex align-items-center gap-6 user-select-none">
          <div className="custom_check_box d-flex">
            <input 
              type="checkbox" 
              className="form-check-input m-0 p-0" 
              name="Taping"
              id="Taping"
              checked={assessmentMethodUsed?.Taping === "true"}
              onChange={handleAssessmentMethodUsed}
            />
          </div>
          <p className="text lh-12">Tapping</p>
        </label>
        <label className="d-flex align-items-center gap-6 user-select-none">
          <div className="custom_check_box d-flex">
            <input 
              type="checkbox" 
              className="form-check-input m-0 p-0" 
              name="TriggerPoint"
              id="TriggerPoint"
              checked={assessmentMethodUsed?.TriggerPoint === "true"}
              onChange={handleAssessmentMethodUsed}
            />
          </div>
          <p className="text lh-12">Trigger Point</p>
        </label>
      </div>

      <div className="d-flex flex-column gap-2">
        <label className="d-flex align-items-center gap-6 user-select-none">
          <div className="custom_check_box d-flex">
            <input 
              type="checkbox" 
              className="form-check-input m-0 p-0" 
              name="Other"
              id="Other"
              checked={assessmentMethodUsed?.Other === "true"}
              onChange={handleAssessmentMethodUsed}
            />
          </div>
          <p className="text lh-12">Other</p>
        </label>
      </div>
    </div>
  )
}

export default AssessmentMethodUsed